/**
 * Helpers for the applicant dashboard "select listing" confirmation dialog.
 *
 * Angular parity (application-list.component.ts ~lines 138-140): the message bolds the
 * property/unit and renders the irreversible NOTE in red. React's ConfirmDialog renders
 * this via its `htmlMessage` prop, so we assemble safe HTML here.
 */

/** Escape data-derived text before injecting into HTML (XSS-safe). */
export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

/**
 * Build the selection-confirmation message as HTML for ConfirmDialog.htmlMessage.
 * - property name (and unit number, when present) are bolded
 * - the "auto cancelled and cannot be reversed" NOTE is red (Angular parity)
 * - an optional server error is appended (escaped)
 */
export function buildSelectionConfirmHtml(
  propertyName: string,
  unitNumber?: string | null,
  error?: string | null,
): string {
  const unitPart =
    unitNumber && unitNumber.trim()
      ? ` with Unit Number <strong>"${escapeHtml(unitNumber)}"</strong>`
      : ''
  return [
    `You have selected <strong>"${escapeHtml(propertyName)}"</strong>${unitPart}.`,
    'Please confirm if you would like to go ahead with this selection.',
    `<span style="color: red;">NOTE: Post confirmation, all your other active records will get auto cancelled and cannot be reversed!!</span>`,
    error && error.trim() ? escapeHtml(error) : '',
  ]
    .filter(Boolean)
    .join('<br><br>')
}
